import { render, staticRenderFns } from "./BarraLateralAdmin.vue?vue&type=template&id=686aa755"
import script from "./BarraLateralAdmin.vue?vue&type=script&lang=ts"
export * from "./BarraLateralAdmin.vue?vue&type=script&lang=ts"
import style0 from "./BarraLateralAdmin.vue?vue&type=style&index=0&id=686aa755&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports